import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { StateCleanupService } from './state-cleanup.service';

export interface DataSource {
  client_id: string;
  embedding_filter: any; // Use 'any' for null or specify a more precise type if known
  id: string;
  location: string;
  name: string;
  source_metadata: any; // Use 'any' for null or specify a more precise type if known
  type: string;
  /** Owner's name, only on internal `__…` buckets (#230). */
  owner_name?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DataSourcesService {
  dataSources$ = new BehaviorSubject<DataSource[]>([]);

  loading$ = new BehaviorSubject<boolean>(false);

  constructor(
    protected http: HttpClient,
    private stateCleanupService: StateCleanupService
  ) {
    this.stateCleanupService.register(() => this.resetState());
  }

  listDataSources() {
    this.loading$.next(true);
    return this.http.get(`${environment.tutorsBackend}/data-sources`).pipe(
      map((data: any) => {
        this.dataSources$.next(data.data);
        this.loading$.next(false);
        return data.data;
      })
    );
  }

  private resetState() {
    this.dataSources$.next([]);
    this.loading$.next(false);
  }
}
